<div class="idp-standby-message" [id]="content.id">
  <div *ngIf="content.title" class="idp-standby-message__title">
    {{ content.title }}
  </div>
  <section class="idp-standby-message__container">
    <div
      *ngIf="content.message"
      class="idp-standby-message__container--message"
    >
      <span class="idp-standby-message__container--body">
        <i aria-hidden="true" class="idp-standby-message__container--icon"></i>
        <span
          [innerHTML]="content.message"
          aria-atomic="true"
          aria-live="polite"
          class="idp-standby-message__container--text"
        ></span>
      </span>
    </div>
    <div class="idp-standby-message__container--btn-section">
      <idp-button
        (notify)="redirect(content.action.url)"
        [label]="content.action.label"
        [size]="'full-width'"
        [id]="content.action.id || '#'"
        class="idp-standby-message__container--btn"
      ></idp-button>
    </div>
  </section>
</div>
